export default "__VITE_ASSET__DP9ONocx__"